import { useContext, useState, useEffect } from "react";
import Button from "../../atoms/button";
import Loading from "../../atoms/loading";
import { getPartnerProducts } from "../functions";
import PartnerProductsList from "./partnerProductsList";
import { partnerStatusList, partnerStatusObject } from "../../utils/allProductStatus";
import PartnerProductModal from "../partnerProductModal/partnerProductModal";
import ToastContext from "../../../context/toastProvider";
import CreateProductModal from "../createProduct/createProductModal";
import ChevronIcon from "../../../img/chevronIcon";
import { useNavigate } from "react-router-dom";

const PartnerProducts = ({ user }) => {

    const { badToast } = useContext(ToastContext);
    const navigate = useNavigate();

    const [searchName, setSearchName] = useState("");
    const [searchEmail, setSearchEmail] = useState("");
    const [searchId, setSearchId] = useState("");
    const [searchStatus, setSearchStatus] = useState("");
    const [selectStatus, setSelectStatus] = useState(false);
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState({});
    const [edit, setEdit] = useState(false);
    const [editableProduct, setEditableProduct] = useState(null);
    const [createModal, setCreateModal] = useState(false);

    const searchProducts = async () => {
        const data = await getPartnerProducts(user?.token, searchEmail, searchId, searchStatus);
        setProducts(data);
        setLoading(false)
        if (products.type === "error") {
            badToast("Erro ao buscar produtos!")
        }
    }

    const handleSearch = () => {
        setLoading(true)
        searchProducts();
    }

    const handleSelectStatus = (e) => {
        e.stopPropagation();
        setSelectStatus(!selectStatus);
    }

    const returnStatus = (statuses) => {
        if (statuses.length === 1) {
            return partnerStatusObject[statuses[0]];
        }
        return statuses.map(s => partnerStatusObject[s]).join(", ").slice(0, 20) + "...";
    }

    const handleAllStatus = () => {
        if (searchStatus?.length < partnerStatusList?.length) {
            return setSearchStatus(partnerStatusList);
        }
        setSearchStatus([]);
    }

    const handleStatusOption = (sts) => {
        if (searchStatus.includes(sts)) {
            setSearchStatus(s => s.filter(sta => sta !== sts));
            return null;
        }
        setSearchStatus(s => [...s, sts]);
    }

    const handleCreate = () => {
        navigate("/partner/products/create", { state: null });
    }

    useEffect(() => {
        handleSearch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <main className="text-center">
            {
                !user.store ?
                    <p className="mt-4">Você não possui um reino parceiro</p>
                    : null
            }
            <h1>Pedidos</h1>
            <div className="border-b border-t border-[#d59106] p-2">
                <div className="inline">
                    <input className="m-2 text-black px-1" type="text" placeholder="Nome do usuário" value={searchName} onChange={e => setSearchName(e.target.value)} />
                    <input className="m-2 text-black px-1" type="text" placeholder="ID do pedido" value={searchId} onChange={e => setSearchId(e.target.value)} />
                    <input className="m-2 text-black px-1" type="text" placeholder="Email do usuário" value={searchEmail} onChange={e => setSearchEmail(e.target.value)} />
                    <Button click={handleSearch} classes="bg-[#d59106] hover:bg-[#b47c06] inline ml-4">{searchName === "" && searchEmail === "" && searchId === "" && searchStatus === "" ? "Pesquisar todos" : "Pesquisar"}</Button>
                </div>
                <Button classes="bg-blue-300 hover:bg-blue-400 inline ml-4" click={handleCreate}>Criar Pedido</Button>
                <label className="w-fit m-auto flex gap-2">Status:
                    <div>
                        <div onClick={handleSelectStatus} className="px-2 cursor-pointer bg-white text-black flex gap-2 justify-center items-center">
                            <p>{searchStatus.length ? returnStatus(searchStatus) : "Todos"}</p>
                            <div className="transform" style={{ rotate: selectStatus ? "180deg" : null }}>
                                <ChevronIcon fill="#000" width="20px" />
                            </div>
                        </div>
                        {
                            selectStatus ?
                                <div onClick={e => e.stopPropagation()} className="relative text-laranjinha w-fit text-center text-black m-auto border border-[#666] max-h-[300px] overflow-y-auto bg-[#222]">
                                    <div className="cursor-pointer h-10 flex justify-center items-center hover:bg-[#333]" onClick={handleAllStatus}>Todos</div>
                                    {
                                        partnerStatusList.map((s, i) => (
                                            <div className="p-2 flex gap-2 cursor-pointer h-10 hover:bg-[#333]" key={i} onClick={() => handleStatusOption(s)}>
                                                <div className="border w-6 h-6 border-primary">
                                                    {
                                                        searchStatus.includes(s) ?
                                                            <p>X</p>
                                                            : null
                                                    }
                                                </div>
                                                <p>{partnerStatusObject[s]}</p>
                                            </div>
                                        ))
                                    }
                                </div>
                                : null
                        }
                    </div>
                </label>
            </div>
            {
                loading ? <Loading classes="m-auto" />
                    : products?.type === "success" ?
                        <PartnerProductsList products={products.data} setEdit={setEdit} setEditableProduct={setEditableProduct} />
                        : products?.type === "error" ?
                            <div>
                                <p className="text-center m-8 text-red-600">{products.message}</p>
                            </div>
                            : null
            }
            {
                edit ? <PartnerProductModal setEdit={setEdit} editableProduct={editableProduct} refresh={handleSearch} /> : null
            }
            {
                createModal ? <CreateProductModal user={user} setEdit={setCreateModal} refresh={handleSearch} partner={true} /> : null
            }
        </main>
    )
}

export default PartnerProducts;